var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow"),React.createElement("path",{"d":"M10.15,16,0,8,10.15,0l1.08,1.42-8,5.79,4.36-.06H17V8.76H7.68l-4.37,0,7.92,5.82Z","key":1})]);
}

Arrow.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 17 16"};

module.exports = Arrow;

Arrow.default = Arrow;
